import {
  AppliedModel,
  AppliedVersion,
  CommonModelType,
  commonModelTypeToFilterFunction,
  COMMON_MODEL_TO_CONTEXT_KEY,
  Model,
  ModelState,
  ModelVersion,
} from "./../models/state/model";
import {
  ModelAndVersionOptions,
  ModelContext,
  ModelOption,
  ModelsWithVersions,
  ModelVersionWithApplied,
} from "./state/context.model";

const getInitialModelAndVersionOptions = () => {
  const INITIAL_MODELS_WITH_VERSIONS: ModelsWithVersions = {
    models: [],
    versionsForModels: {},
    focusedVersions: [],
  };
  const INITIAL_MODEL_AND_VERSION_OPTIONS: ModelAndVersionOptions = {
    sentiment: { ...INITIAL_MODELS_WITH_VERSIONS },
    intent: { ...INITIAL_MODELS_WITH_VERSIONS },
    emotion: { ...INITIAL_MODELS_WITH_VERSIONS },
    topic: { ...INITIAL_MODELS_WITH_VERSIONS },
    category: { ...INITIAL_MODELS_WITH_VERSIONS },
  };
  return INITIAL_MODEL_AND_VERSION_OPTIONS;
};

const checkIfModelVersionHasNotBeenApplied = (
  context: any,
  modelAndVersionOptions: ModelAndVersionOptions,
  modelType: string,
) => {
  const modelKey = COMMON_MODEL_TO_CONTEXT_KEY[modelType];
  const selectedModelVersion = context[modelKey]?.version?.uuid;
  const availableModelVersions =
    modelAndVersionOptions[modelType]?.focusedVersions;

  const returnValue = availableModelVersions?.some(
    (version) => version.uuid === selectedModelVersion && !version.applied,
  );

  return returnValue;
};

const getTypesModelsWithVersions = (
  type: CommonModelType,
  appliedModels: AppliedModel[],
  context: any,
  modelState: ModelState,
): ModelsWithVersions => {
  const { modelIDs, versionIDs } = getModelAndVersionIDs(appliedModels);

  const filterFunction = commonModelTypeToFilterFunction[type];

  const models: ModelOption[] = modelState.summaries
    .filter(filterFunction)
    .map((model: Model) => {
      return {
        ...model,
        applied: modelIDs.includes(model.uuid),
      };
    });

  let versionsForModels: { [modelID: string]: ModelVersionWithApplied[] } = {};
  models.forEach((model: Model) => {
    versionsForModels[model.uuid] = modelState.versions
      .filter((version: ModelVersion) => version.model_id === model.uuid)
      .map((version: ModelVersion) => {
        return {
          ...version,
          applied: versionIDs.includes(version.uuid),
        };
      });
  });

  const contextKey = COMMON_MODEL_TO_CONTEXT_KEY[type];
  const currentContext: ModelContext = context[contextKey] as ModelContext;

  return {
    models,
    versionsForModels,
    focusedVersions: versionsForModels[currentContext?.model.uuid]?.sort(
      (a, b) => a.version_number - b.version_number,
    ),
  };
};

const getModelAndVersionIDs = (
  appliedModels: AppliedModel[],
): {
  modelIDs: string[];
  versionIDs: string[];
} => {
  const modelIDs: string[] = [];
  const versionIDs: string[] = [];

  appliedModels.forEach((appliedModel: AppliedModel) => {
    modelIDs.push(appliedModel.model_id);
    appliedModel.versions.forEach((appliedVersion: AppliedVersion) => {
      versionIDs.push(appliedVersion.version_id);
    });
  });

  return { modelIDs, versionIDs };
};

export const ContextUtils = {
  getInitialModelAndVersionOptions,
  checkIfModelVersionHasNotBeenApplied,
  getTypesModelsWithVersions,
  getModelAndVersionIDs,
};
